import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2cc1bb06"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "DashboardEvents" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("picture", null, [
  /*#__PURE__*/_createElementVNode("source", { srcset: "/images/events/empty.png 1x, /images/events/empty@2x.png 2x" }),
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/events/empty.png",
    alt: "program started image"
  })
], -1))
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 1,
  class: "DashboardEvents_list"
}
const _hoisted_5 = { class: "DashboardEvents_text" }
const _hoisted_6 = { class: "DashboardEvents_button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EventsCalendarItem = _resolveComponent("EventsCalendarItem")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_ButtonHover = _resolveComponent("ButtonHover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state === 'no-events')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["DashboardEvents_noevents", [_ctx.state]])
        }, [
          _hoisted_2,
          _createElementVNode("p", {
            innerHTML: _ctx.$t('dashboard.events_no')
          }, null, 8, _hoisted_3)
        ], 2))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (event) => {
            return (_openBlock(), _createBlock(_component_RouterLink, {
              to: `/events/${event.id}`,
              key: 'dashboard-event-' + event.id
            }, {
              default: _withCtx(() => [
                _createVNode(_component_EventsCalendarItem, {
                  date: event.start_date,
                  place: event.city,
                  class: "DashboardEvents_listItem"
                }, null, 8, ["date", "place"])
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128))
        ])),
    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('dashboard.events_available')), 1),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_ButtonHover, {
        to: "/events",
        class: "button"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('dashboard.events_board')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}